import FooterButton from "../footer/footerButton";
import "./wrong.css";
function Wrong({ onClose }) {
  return (
    <div id="content" className="wrongDiv">
      <div class="boxPop content_box1">
        <div className="box_con ">
          <div className="missionDiv missionDivPopHeight">
            <div className="missionDi">
              <div className="mission_txt_b ">
                틀린 것 같아...
                <br />
                다시 찾아보자!
              </div>
              <FooterButton
                ftIdName="box_ft"
                buttonClass="inputBtn02 con_box_wrong_btn"
                buttonValue="돌아가기"
                onFinish={onClose}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Wrong;
